import { Route, Routes, useParams } from 'react-router-dom'
import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useNewsItem, useNewsItems } from 'app/frontend/base/config/queries'
import { uploadFile } from 'app/frontend/base/api/team'
import NewsIndex from 'app/frontend/base/pages/shared/News/NewsIndex'
import NewsForm from 'app/frontend/base/pages/shared/News/NewsForm'
import NewsView from 'app/frontend/base/pages/shared/News/NewsView'

const TeamNewsIndex = () => {
  const { team } = useTeam()
  const { data: newsItems, isPending } = useNewsItems(team.id)

  return (
    <NewsIndex
      newsItems={newsItems}
      isPending={isPending}
      teamName={team.name}
      createPermission={{ section: 'news', requirement: 'admin' }}
      editPermissionForItem={(item) => ({
        section: 'news',
        requirement: 'admin',
        requireAllTeams: item.newsableType === 'Guild',
      })}
    />
  )
}

const TeamNewsForm = () => {
  const { guild, team } = useTeam()
  const { id } = useParams()
  const newsItemId = id ? parseInt(id) : undefined
  const { data: existingItem, isPending } = useNewsItem(team.id, newsItemId)

  return (
    <NewsForm
      parentEntityType='team'
      parentId={team.id}
      existingItem={existingItem}
      isPending={isPending}
      listQueryKey={['newsItems', { teamId: team.id }]}
      guildNewsQueryKey={['guildNewsItems', { guildId: guild.id }]}
      uploadFile={async (file) => (await uploadFile(team.id, file)).url}
      showTargetSelector={true}
      defaultTarget='team'
      formPermission={(item) => ({
        section: 'news',
        requirement: 'admin',
        requireAllTeams: item.target === 'guild',
      })}
    />
  )
}

const TeamNewsView = () => {
  const { team } = useTeam()
  const { id } = useParams()
  const newsItemId = id ? parseInt(id) : undefined
  const { data: newsItem, isPending } = useNewsItem(team.id, newsItemId)

  return (
    <NewsView
      newsItem={newsItem}
      isPending={isPending}
      teamName={team.name}
      editPermission={{
        section: 'news',
        requirement: 'admin',
        requireAllTeams: newsItem?.newsableType === 'Guild',
      }}
    />
  )
}

const TeamNewsRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<TeamNewsIndex />} />
      <Route path='/new' element={<TeamNewsForm />} />
      <Route path='/:id' element={<TeamNewsView />} />
      <Route path='/:id/edit' element={<TeamNewsForm />} />
    </Routes>
  )
}

const TeamNews = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`News | ${team.name} | ${guild.name}`}>
      <TeamNewsRoutes />
    </Section>
  )
}

export default TeamNews
